import styles from "./checkout.module.scss";
import { Alert, Button, Dialog, IconButton, Paper,  Typography, } from "@mui/material";
import { forwardRef } from "react";
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import { useAppDispatch, useAppSelector } from "store/hooks";
import { handleToggleCheckout, resetYears } from "store/wizard";
import { Close } from "mdi-material-ui";
import Chart from "features/chart/Chart";
import CallToAction from "./components/CallToAction";
import Breakdown from "./components/Breakdown";
import Form from "./components/Form";
import { setActiveDialog } from "store/app";
import { DialogType } from "store/app/types";
import Slider from "./components/Slider";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Fade in={true} ref={ref} {...props} />;
});

const Checkout = () => {
  const dispatch = useAppDispatch();
  const { checkout } = useAppSelector((state) => state.wizard);
  const { user } = useAppSelector((state) => state.app);

  const handleClose = () => {
    dispatch(handleToggleCheckout(false));
    dispatch(resetYears());
  }

  return (
    <>
      <Dialog
        fullScreen
        open={checkout}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div className={`${styles.glow}`}/>
        <div className="container-fluid">
          <div className="row my-1 align-items-center mb-5 mb-lg-0">
            <div className="col-6">
              <Typography variant="h6" fontWeight={700}>Plant Trees Now</Typography>
            </div>
            <div className="col-6 text-end">
              <IconButton 
                onClick={handleClose}
              >
                <Close/>
              </IconButton>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mb-3">
            <div className="col-12 d-flex justify-content-center">
              <CallToAction/>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <Chart/>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-6 col-12">
              <Paper className={`${styles.paper}`} elevation={3}>
                <Breakdown/>
                <Slider/>
              </Paper>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-6 col-12">
              <Paper className={`${styles.paper}`} elevation={3}>
                {
                  !user ? (
                    <>
                      <Alert severity="error" className="mb-3">Please login or create an account to continue</Alert>
                      <div className="d-flex">
                        <Button 
                          onClick={() => dispatch( setActiveDialog(DialogType.Signup) )}
                          fullWidth className="me-2" variant="contained" color="primary" disableElevation
                          >
                            Create New Account
                        </Button>
                        <Button 
                          onClick={() => dispatch( setActiveDialog(DialogType.Login) )}
                          fullWidth className="ms-2" variant="contained" color="primary" disableElevation
                          >
                            Login
                        </Button>
                      </div>
                    </>
                  ) : <Form/>
                }
              </Paper>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default Checkout;
